<template>
  <div class="wrap">
    <p class="back" @click="goBack">
      {{lang.back}}
      <span class="iconfont icon-back-right"></span>
    </p>
    <p class="title01">{{lang.inviteFriends}}</p>
    <p class="title02">{{lang.getCommission}}</p>
    <p class="titbtn" @click="getData">{{lang.refresh}}</p>
    <div class="content">
      <p class="reward">{{lang.invitationReward}} {{reward}}Rs</p>
      <p class="ewm" id="qrcodeDom"></p>
      <p class="code">{{yqm}}</p>
      <p class="user">{{lang.invited}}<b>{{invited}}</b>{{lang.user}}</p>
      <p class="btn tag-read" :data-clipboard-text="link" @click="copydz">{{lang.copyInviteCode}}</p>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {mapState} from 'vuex';
  import Clipboard from 'clipboard';
  import QRCode from 'qrcodejs2'
  export default {
    data() {
      return {
        url:'',
        link:'',
        yqm:'',
        reward:0,
        invited:0
      }
    },
    created() {
      this.getData()
    },
    computed: {
			...mapState(['lang'])
		},
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      getData() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/member/inviteCode')
          .then(res => {
            this.$indicator.close();
            this.yqm = res.data.code;
            this.link = res.data.url+'/#/Reg?code='+res.data.code;
            this.reward = res.data.reward;
            this.invited = res.data.invited;
            document.getElementById('qrcodeDom').innerHTML='';
            new QRCode('qrcodeDom',{
              width: 120,
              height:120,
              text: this.link//需要转换的链接
            })
          })
          .catch(error => {
            this.$indicator.close();
            this.$router.push('/');
          })
      },
      copydz() {
        var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
          this.$toast({
            message: this.lang.copysucc,
            position: 'middle',
            iconClass: 'iconfont icon-chenggong'
          });
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 不支持复制
          this.$toast({
            message: this.lang.copyDefault,
            position: 'middle',
            iconClass: 'icon icon-shibai'
          });
          // 释放内存
          clipboard.destroy()
        })
      }
    }
  }
</script>
<style type="text/css"  scoped>
  .wrap {
    background: url("../../assets/images/invite_bg.jpg");
    background-size: cover;
    color:#fff;
    padding:30px 12px;
  }

  .back{
    position: absolute;
    width:100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    top:24px;
    right:0;
    color:#333;
    background: #fff;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    font-weight: bold;
    padding-left:20px;
  }
  .back span{
    margin-right:5px;
  }


  .title01,.title02,.titbtn{
    font-size:24px;
    font-weight: bold;
    padding-left:20px;
    margin-top:10px;
  }
  .title02{
    padding-left:70px;
  }

  .titbtn{
    width:160px;
    text-align: center;
    margin-left:100px;
    border-radius: 5px;
    background: linear-gradient(35deg,rgba(68, 220, 152,.2),rgba(68, 220, 152,.7));
  }

  .content{
    padding:12px;
    margin:30px 12px;
    box-shadow: 0 3px 5px rgba(197, 197, 197, .5);
    background: #fff url(../../assets/images/zhuangshi.png) center -20px no-repeat;
    background-size:100%;
    color:#333;
    border-radius: 10px;
  }
  .content .reward{
    font-size:18px;
    text-align: center;
    margin-top:50px;
    font-weight: bold;
  }

  .content .ewm{
    width:120px;
    height: 120px;
    margin:12px auto;
  }
  .content .ewm img{
    width:100%;
  }


  .content .code{
    font-size:16px;
    text-align: center;
    margin-top:10px;
  }
  .user{
    font-size:16px;
    text-align: center;
    margin-top:10px;
  }
  .content .code b{
    padding:0 10px;
    color:#fd574f;
  }
  .user b{
    padding:0 10px;
    color:#fd574f;
  }


  .content .code{
    margin-top:24px;
    font-weight: bold;
  }

  .content .btn{
    height: 40px;
    margin: 20px;
    border-radius: 7px;
    line-height: 40px;
    text-align: center;
    color:#fff;
    background: linear-gradient(to right, #3476fe, #34c7fe);
  }
</style>